"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
var Title;
(function (Title) {
    Title[Title["Unknown"] = 0] = "Unknown";
    // Dr.
    Title[Title["Doctor"] = 1] = "Doctor";
    // Prof. Dr.
    Title[Title["ProfDoctor"] = 2] = "ProfDoctor";
    // Dipl. Ing.
    Title[Title["DiplEngineer"] = 3] = "DiplEngineer";
    // Dipl. med.
    Title[Title["DiplDoctor"] = 4] = "DiplDoctor";
    // Dipl. Psych.
    Title[Title["DiplPsych"] = 5] = "DiplPsych";
    // Dr. Dr.
    Title[Title["DoctorDoctor"] = 6] = "DoctorDoctor";
    // Dr. med.
    Title[Title["DoctorMed"] = 7] = "DoctorMed";
    // Prof. Dr. Dr.
    Title[Title["ProfDoctorDoctor"] = 8] = "ProfDoctorDoctor";
    // Prof.
    Title[Title["Prof"] = 9] = "Prof";
    // Prof. Dr. med.
    Title[Title["ProfDoctorMed"] = 10] = "ProfDoctorMed";
    // Rechtsanwalt
    Title[Title["Lawyer"] = 11] = "Lawyer";
    // Rechtsanwältin
    Title[Title["FemaleLawyer"] = 12] = "FemaleLawyer";
    // Schwester
    Title[Title["Sister"] = 13] = "Sister";
    // Dr. jur.
    Title[Title["DoctorJur"] = 14] = "DoctorJur";
    // Firma
    Title[Title["Company"] = 15] = "Company";
    // Freifrau
    Title[Title["Baroness"] = 16] = "Baroness";
    // Freiherr
    Title[Title["Baron"] = 17] = "Baron";
    //Gemeinschaftspraxis
    Title[Title["JointPractice"] = 18] = "JointPractice";
    // Praxis
    Title[Title["Practice"] = 19] = "Practice";
    // Priv.-Doz. Dr. med.
    Title[Title["PrivateLecturerDoctorMed"] = 20] = "PrivateLecturerDoctorMed";
})(Title = exports.Title || (exports.Title = {}));
exports.default = Title;
